import { render, staticRenderFns } from "./PlayerAttachments.vue?vue&type=template&id=36e37f7e&scoped=true&"
import script from "./PlayerAttachments.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachments.vue?vue&type=style&index=0&id=36e37f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e37f7e",
  null
  
)

export default component.exports